import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '..\\layouts\\error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_b4c18228 from 'nuxt_plugin_plugin_b4c18228' // Source: .\\vuetify\\plugin.js (mode: 'all')
import nuxt_plugin_pluginrouting_54dfa02e from 'nuxt_plugin_pluginrouting_54dfa02e' // Source: .\\nuxt-i18n\\plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7842ea01 from 'nuxt_plugin_pluginmain_7842ea01' // Source: .\\nuxt-i18n\\plugin.main.js (mode: 'all')
import nuxt_plugin_axios_692a3a2b from 'nuxt_plugin_axios_692a3a2b' // Source: .\\axios.js (mode: 'all')
import nuxt_plugin_gtm_30398fc1 from 'nuxt_plugin_gtm_30398fc1' // Source: .\\gtm.js (mode: 'all')
import nuxt_plugin_errorHandler_645039de from 'nuxt_plugin_errorHandler_645039de' // Source: ..\\plugins\\errorHandler.js (mode: 'client')
import nuxt_plugin_gmaps_1d50f2e0 from 'nuxt_plugin_gmaps_1d50f2e0' // Source: ..\\plugins\\gmaps.js (mode: 'client')
import nuxt_plugin_vueObserveVisibility_beebb250 from 'nuxt_plugin_vueObserveVisibility_beebb250' // Source: ..\\plugins\\vueObserveVisibility.js (mode: 'all')
import nuxt_plugin_global_f21f4e84 from 'nuxt_plugin_global_f21f4e84' // Source: ..\\plugins\\global.js (mode: 'all')
import nuxt_plugin_crisp_67670e56 from 'nuxt_plugin_crisp_67670e56' // Source: ..\\plugins\\crisp.js (mode: 'client')
import nuxt_plugin_vueAzureUploader_21d5192a from 'nuxt_plugin_vueAzureUploader_21d5192a' // Source: ..\\plugins\\vueAzureUploader.js (mode: 'client')
import nuxt_plugin_virtualScroller_1b07d168 from 'nuxt_plugin_virtualScroller_1b07d168' // Source: ..\\plugins\\virtualScroller.js (mode: 'client')
import nuxt_plugin_clientOnly_94720e6c from 'nuxt_plugin_clientOnly_94720e6c' // Source: ..\\plugins\\clientOnly.js (mode: 'client')
import nuxt_plugin_msal_92663776 from 'nuxt_plugin_msal_92663776' // Source: ..\\plugins\\msal (mode: 'all')
import nuxt_plugin_msalaccessor_701a9f80 from 'nuxt_plugin_msalaccessor_701a9f80' // Source: ..\\plugins\\msal-accessor.ts (mode: 'all')
import nuxt_plugin_i18naccessor_6fc285cd from 'nuxt_plugin_i18naccessor_6fc285cd' // Source: ..\\plugins\\i18n-accessor.ts (mode: 'all')
import nuxt_plugin_i18n_1fba4fce from 'nuxt_plugin_i18n_1fba4fce' // Source: ..\\plugins\\i18n.ts (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s | Gritify","title":"Gritify","script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-MGKXBG2')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"},{"name":"facebook-domain-verification","content":"bzsqcs1ou9k1au8yyeydw2thiqp5kr"},{"hid":"description","name":"description","content":"Använd gritify.io för att aldrig missa ett drömjobb. Här är du anonym. Ange dina preferenser och vilken lön du vill ha. Rekrytering på dina villkor."}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fgriticon.png"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-MGKXBG2&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_b4c18228 === 'function') {
    await nuxt_plugin_plugin_b4c18228(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_54dfa02e === 'function') {
    await nuxt_plugin_pluginrouting_54dfa02e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7842ea01 === 'function') {
    await nuxt_plugin_pluginmain_7842ea01(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_692a3a2b === 'function') {
    await nuxt_plugin_axios_692a3a2b(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_30398fc1 === 'function') {
    await nuxt_plugin_gtm_30398fc1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_errorHandler_645039de === 'function') {
    await nuxt_plugin_errorHandler_645039de(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gmaps_1d50f2e0 === 'function') {
    await nuxt_plugin_gmaps_1d50f2e0(app.context, inject)
  }

  if (typeof nuxt_plugin_vueObserveVisibility_beebb250 === 'function') {
    await nuxt_plugin_vueObserveVisibility_beebb250(app.context, inject)
  }

  if (typeof nuxt_plugin_global_f21f4e84 === 'function') {
    await nuxt_plugin_global_f21f4e84(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_crisp_67670e56 === 'function') {
    await nuxt_plugin_crisp_67670e56(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueAzureUploader_21d5192a === 'function') {
    await nuxt_plugin_vueAzureUploader_21d5192a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_virtualScroller_1b07d168 === 'function') {
    await nuxt_plugin_virtualScroller_1b07d168(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clientOnly_94720e6c === 'function') {
    await nuxt_plugin_clientOnly_94720e6c(app.context, inject)
  }

  if (typeof nuxt_plugin_msal_92663776 === 'function') {
    await nuxt_plugin_msal_92663776(app.context, inject)
  }

  if (typeof nuxt_plugin_msalaccessor_701a9f80 === 'function') {
    await nuxt_plugin_msalaccessor_701a9f80(app.context, inject)
  }

  if (typeof nuxt_plugin_i18naccessor_6fc285cd === 'function') {
    await nuxt_plugin_i18naccessor_6fc285cd(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba4fce === 'function') {
    await nuxt_plugin_i18n_1fba4fce(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    router.push(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
